import { useState } from "react";

const features = [
  {
    id: 1,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26">
        <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
      </svg>
    ),
    title: "Online Music",
    desc: "Stream unlimited spiritual songs anytime, anywhere",
  },
  {
    id: 2,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26">
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
      </svg>
    ),
    title: "Download Music",
    desc: "Download your favorite bhajans for offline listening",
  },
  {
    id: 3,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26">
        <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/>
        <path d="M12 11.5v5.3c-.3-.2-.6-.3-1-.3-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2v-4.5l2 .5V13l-3-1.5z"/>
      </svg>
    ),
    title: "Download Tracks",
    desc: "High quality audio tracks for meditation",
  },
  {
    id: 4,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26">
        <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 8H10V8h8v2zm-4 4H10v-2h4v2zm4 0h-2v-2h2v2z"/>
      </svg>
    ),
    title: "Personalized Playlists",
    desc: "Create and manage your custom playlists",
  },
  {
    id: 5,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26">
        <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
      </svg>
    ),
    title: "Live Events",
    desc: "Join live spiritual music events and satsangs",
  },
  {
    id: 6,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26">
        <path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"/>
        <path d="M10 8l6 4-6 4V8z"/>
      </svg>
    ),
    title: "App Events",
    desc: "Exclusive in-app spiritual gatherings",
  },
];

export default function AboutUs() {
  const [hovered, setHovered] = useState(null);

  return (
    <section className="about-section">
      {/* Subtle background texture dots */}
      <div className="bg-dots" />

      <div className="container">
        {/* ── Header ── */}
        <div className="header">
          <span className="eyebrow">WHO WE ARE</span>
          <h2 className="heading">ABOUT US</h2>
          <div className="heading-underline" />
          <p className="description">
            संगीत विद्यालय शिवाजी एक आध्यात्मिक संगीत मंच आहे जो भक्तिगीत, आरती आणि भजनांचा अनमोल
            संग्रह ऑफर करते। आमचे उद्दिष्ट आहे प्रत्येक भक्तापर्यंत आध्यात्मिक संगीत पोहोचवणे आणि त्यांच्या
            आत्मिक प्रवासात सहाय्य करणे।
          </p>
        </div>

        {/* ── Feature Cards Grid ── */}
        <div className="grid">
          {features.map((f) => {
            const isHovered = hovered === f.id;
            return (
              <div
                key={f.id}
                className={`card ${isHovered ? "card--hovered" : ""}`}
                onMouseEnter={() => setHovered(f.id)}
                onMouseLeave={() => setHovered(null)}
                onTouchStart={() => setHovered(f.id)}
                onTouchEnd={() => setHovered(null)}
              >
                {/* Icon circle */}
                <div className={`icon-circle ${isHovered ? "icon-circle--hovered" : ""}`}>
                  <span className="icon-wrapper">{f.icon}</span>
                </div>

                <h3 className={`card-title ${isHovered ? "card-title--hovered" : ""}`}>
                  {f.title}
                </h3>
                <p className="card-desc">{f.desc}</p>

                {/* Hover bottom accent */}
                <div className={`card-accent ${isHovered ? "card-accent--hovered" : ""}`} />
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700;800&family=Noto+Sans+Devanagari:wght@400;500;600&display=swap');

        *, *::before, *::after {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Section ── */
        .about-section {
          background: #fdf6ec;
          min-height: 100vh;
          position: relative;
          overflow: hidden;
          padding: 80px 48px 100px;
          font-family: 'Noto Sans Devanagari', sans-serif;
          display: flex;
          align-items: flex-start;
          justify-content: center;
        }

        /* ── Background dots ── */
        .bg-dots {
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(139,26,26,0.06) 1px, transparent 1px);
          background-size: 32px 32px;
          pointer-events: none;
        }

        /* ── Container ── */
        .container {
          position: relative;
          z-index: 1;
          max-width: 1200px;
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 60px;
          animation: fadeInUp 0.7s ease both;
        }

        /* ── Header ── */
        .header {
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
        }

        .eyebrow {
          font-family: 'Cinzel', serif;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 5px;
          color: #c0392b;
          text-transform: uppercase;
        }

        .heading {
          font-family: 'Cinzel', serif;
          font-size: clamp(36px, 5vw, 60px);
          font-weight: 800;
          color: #1a0808;
          letter-spacing: 4px;
          line-height: 1.1;
        }

        .heading-underline {
          width: 60px;
          height: 4px;
          background: linear-gradient(90deg, #c0392b, #922b21);
          border-radius: 2px;
          margin-top: -4px;
        }

        .description {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 16px;
          color: #4a2020;
          line-height: 1.9;
          max-width: 740px;
          text-align: center;
          opacity: 0.85;
        }

        /* ── Grid ── */
        .grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        /* ── Card ── */
        .card {
          background: #ffffff;
          border-radius: 16px;
          border: 1.5px solid rgba(139,26,26,0.07);
          padding: 40px 32px 36px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
          text-align: center;
          cursor: pointer;
          transition:
            transform 0.3s cubic-bezier(0.34,1.56,0.64,1),
            box-shadow 0.3s ease,
            border-color 0.3s ease;
          position: relative;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(0,0,0,0.06);
        }

        .card--hovered {
          transform: translateY(-6px);
          box-shadow: 0 16px 40px rgba(139,26,26,0.15), 0 4px 12px rgba(0,0,0,0.08);
          border-color: rgba(139,26,26,0.15);
        }

        /* ── Icon Circle ── */
        .icon-circle {
          width: 72px;
          height: 72px;
          border-radius: 50%;
          background: linear-gradient(135deg, #8b1a1a 0%, #c0392b 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          transition:
            transform 0.3s cubic-bezier(0.34,1.56,0.64,1),
            box-shadow 0.3s ease;
          flex-shrink: 0;
          box-shadow: 0 4px 12px rgba(139,26,26,0.25);
        }

        .icon-circle--hovered {
          transform: scale(1.08);
          box-shadow: 0 8px 24px rgba(139,26,26,0.4);
        }

        .icon-wrapper {
          color: #d4a857;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* ── Card Title ── */
        .card-title {
          font-family: 'Cinzel', serif;
          font-size: 17px;
          font-weight: 700;
          letter-spacing: 0.3px;
          transition: color 0.2s ease;
          line-height: 1.3;
          color: #1a1a1a;
        }

        .card-title--hovered {
          color: #8b1a1a;
        }

        /* ── Card Desc ── */
        .card-desc {
          font-family: sans-serif;
          font-size: 14px;
          color: #666;
          line-height: 1.65;
          max-width: 260px;
        }

        /* ── Card Accent ── */
        .card-accent {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          height: 3px;
          background: linear-gradient(90deg, #c0392b, #d4a857);
          border-radius: 2px 2px 0 0;
          transition: width 0.3s ease;
          width: 0px;
        }

        .card-accent--hovered {
          width: 48px;
        }

        /* ════════════════════════════════════
           RESPONSIVE BREAKPOINTS
        ════════════════════════════════════ */

        /* ── Tablet: 768px – 1024px ── */
        @media (max-width: 1024px) {
          .about-section {
            padding: 64px 32px 80px;
          }

          .grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }

          .container {
            gap: 48px;
          }
        }

        /* ── Large Mobile / Small Tablet: 600px – 767px ── */
        @media (max-width: 767px) {
          .about-section {
            padding: 56px 24px 72px;
          }

          .container {
            gap: 40px;
          }

          .heading {
            letter-spacing: 2px;
          }

          .eyebrow {
            letter-spacing: 3px;
          }

          .description {
            font-size: 15px;
          }

          .grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }

          .card {
            padding: 28px 20px 28px;
            gap: 12px;
          }

          .card-title {
            font-size: 15px;
          }

          .icon-circle {
            width: 60px;
            height: 60px;
          }

          .icon-circle svg {
            width: 22px;
            height: 22px;
          }
        }

        /* ── Mobile: up to 480px ── */
        @media (max-width: 480px) {
          .about-section {
            padding: 48px 16px 64px;
          }

          .container {
            gap: 32px;
          }

          .eyebrow {
            font-size: 10px;
            letter-spacing: 2.5px;
          }

          .heading {
            font-size: clamp(28px, 8vw, 40px);
            letter-spacing: 1.5px;
          }

          .description {
            font-size: 14px;
            line-height: 1.8;
          }

          .grid {
            grid-template-columns: 1fr 1fr;
            gap: 12px;
          }

          .card {
            padding: 24px 16px 24px;
            gap: 10px;
            border-radius: 12px;
          }

          .icon-circle {
            width: 52px;
            height: 52px;
          }

          .card-title {
            font-size: 13px;
            letter-spacing: 0;
          }

          .card-desc {
            font-size: 12px;
            line-height: 1.55;
            max-width: 100%;
          }
        }

        /* ── Very Small Mobile: up to 360px ── */
        @media (max-width: 360px) {
          .grid {
            grid-template-columns: 1fr;
          }

          .card {
            padding: 28px 24px;
          }

          .card-desc {
            font-size: 13px;
            max-width: 280px;
          }
        }
      `}</style>
    </section>
  );
}